import React from 'react';

import Shape2 from '../../images/cta-shap-2.svg'
import Shape3 from '../../images/cta-shap-3.svg'
import './CtaJoinUs.css'

const CtaJoinUs = ({ onVolunteerClick }) => {
    return (
        <section className="cta-section-s3">
            <div className="container">
                <div className="cta-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-8 col-12">
                            <div className="content">
                                <h2>Join Our Community</h2>
                                <h3>Make a Difference Today</h3>
                                <ul>
                                    <li><i className="flaticon-check"></i>Volunteer your time and skills</li>
                                    <li><i className="flaticon-check"></i>Support us on Patreon</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="all-btn">
                                <button onClick={onVolunteerClick} className="theme-btn">
                                    Become a Volunteer <i className="flaticon-heart"></i>
                                </button>
                                <a href="https://www.patreon.com" target="_blank" rel="noopener noreferrer" className="theme-btn patreon-btn">
                                    Become a Patreon <i className="flaticon-heart"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="shape">
                        <img src={Shape2} alt="" />
                    </div>
                    <div className="shape1">
                        <img src={Shape3} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaJoinUs;
